module.exports = __webpack_public_path__ + "static/img/shang_hai.3c941e56.png";